import { Box, Typography } from "@mui/material";

interface IProps {
  title: string;
  children: any;
}

const SectionWrapper = (props: IProps) => {
  const { title, children } = props;

  return (
    <Box mb={4}>
      <Typography variant="h5" color="primary" fontWeight={500} sx={{ lineHeight: 1,fontSize: { xs: '18px', sm: '20px' } }} >
        {title}
      </Typography>
      <Box mt={2}>{children}</Box>
    </Box>
  );
};

export default SectionWrapper;
